import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class OccupationAreasService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http
      .get(environment.apiUrl + 'admin/area', httpOptions)
      .pipe(map((result) => result));
  }
}
